import { http, HttpResponse } from 'msw';

import { PlaidItem } from 'services/hurdlr/queries/useHurdlrPlaidItems/useHurdlrPlaidItems.interface';
import { BankStatementAvailabilityItem } from 'services/bookkeeping/queries/useBankStatementsAvailabilityList/useBankStatementsAvailabilityList.interface';
import { InstitutionRequest } from 'services/plaid/queries/usePlaidInstitutionById/usePlaidInstitutionById.interface';

export default {
    plaidItems: http.get('*/hurdlr/member/plaid-items/', () => HttpResponse.json([] satisfies PlaidItem[])),
    bankStatementsAvailability: http.get('*/bank-statements/availability/', () =>
        HttpResponse.json([] satisfies BankStatementAvailabilityItem[])
    ),
    plaidInstitutionById: http.post('*/plaid/institutions/get_by_id/', () =>
        HttpResponse.json({
            institution: {
                institution_id: 'ins_default',
                name: 'Mock Bank',
                products: [],
                country_codes: ['US'],
                routing_numbers: [],
                oauth: false,
                dtc_numbers: [],
                logo: null,
                primary_color: null,
                url: 'https://example.com',
            },
            request_id: 'mock-request-id',
        } satisfies InstitutionRequest)
    ),
};
